<div class="kpi-card">
  <div class="kpi-header"
    [matTooltip]="tooltipText"
    matTooltipPosition="above">
    <h3>{{ title }}</h3>
    <mat-icon class="kpi-icon">{{ icon }}</mat-icon>
  </div>
  <div class="kpi-body-content">
    @if (!isLoading && metricData) {
      <div class="kpi-content">
        @if (metricType !== 'pbiTimeByColumn') {
          <div class="kpi-value">{{ currentAnimatedValue }}</div>
        }
        @if (metricData?.subtitle && metricType !== 'pbiTimeByColumn') {
          <div class="kpi-subtitle">{{ metricData.subtitle }}</div>
        }
        @if (metricType === 'pbiTimeByColumn') {
          <ng-content></ng-content>
        }
        @if (getComparisonDisplay().text) {
          <div class="kpi-comparison"
            [ngClass]="getComparisonDisplay().class"
            >
            {{ getComparisonDisplay().text }}
          </div>
        }
      </div>
    }
    @if (isLoading) {
      <div>
        <mat-spinner [diameter]="60"></mat-spinner>
      </div>
    }
    @if (!isLoading && !metricData && metricType !== 'pbiTimeByColumn') {
      <div class="kpi-content">
        <div class="kpi-value">N/A</div>
      </div>
    }
  </div>
</div>
